import { cva, VariantProps } from 'class-variance-authority';

export const staticNotificationVariants = cva(
  ['flex flex-row gap-x-12 border p-16 items-center'],
  {
    variants: {
      size: {
        default: 'rounded-12 md:rounded-18',
        small: 'rounded-12',
      },
      variant: {
        default: 'bg-grayscale50 border-grayscale300 text-grayscale600',
        success: 'bg-success50 border-success300 text-grayscale600',
        error: 'bg-error50 border-error300 text-grayscale600',
        warning: 'bg-warning50 border-warning300 text-grayscale600',
        info: 'bg-info50 border-info300 text-grayscale600',
      },
    },
    defaultVariants: {
      size: 'default',
      variant: 'info',
    },
  },
);

export type StaticNotificationVariants = VariantProps<
  typeof staticNotificationVariants
>;
